"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _image = _interopRequireDefault(require("@atlaskit/icon/core/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ImageIcon = props => /*#__PURE__*/_react.default.createElement(_base.UNSAFE_IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM10.5 16.5 9 15l-3 3h12v-2.7L15 12zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
}, props, {
  newIcon: _image.default
}));
ImageIcon.displayName = 'ImageIcon';
var _default = exports.default = ImageIcon;